<template>
    <task-group-list
        :experiment="experiment"
        :abstractSchemaConfig="protocol"
        :task-groups="taskSchedule.taskGroups"
        :readout-groups="taskSchedule.readoutGroups"
        :task-references="taskSchedule.taskReferences"
        :task-thing-date-estimates="taskSchedule.taskThingDateEstimates"
        @create="createTaskGroup"
        @update="updateTaskGroup"
        @delete="deleteTaskGroup"
        @saved="taskGroupsSaved"
    />
</template>
<script>
import { defineComponent } from "vue";

import { buildExperimentTaskGroupsAPI } from "@/services/api.services";
import { withLoadingScreen } from "@/lib/loading";
import TaskGroupList from "../Measurements/TaskGroupList.vue";

export default defineComponent({
    components: { TaskGroupList },

    props: {
        taskSchedule: {
            type: Object,
            required: true,
        },
        protocol: {
            type: Object, // AbstractSchemaConfig
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            experimentTaskGroupsAPI: null,
        };
    },

    mounted() {
        this.experimentTaskGroupsAPI = buildExperimentTaskGroupsAPI(this.experiment.code);
    },

    methods: {
        createTaskGroup(taskGroup) {
            return this.save(() => this.experimentTaskGroupsAPI.create(taskGroup));
        },
        updateTaskGroup(taskGroup) {
            return this.save(() => this.experimentTaskGroupsAPI.update(taskGroup));
        },
        async save(saveFn) {
            return withLoadingScreen(async () => {
                const savedTaskGroup = await saveFn();
                this.$emit("saved", savedTaskGroup);
            });
        },
        async deleteTaskGroup(taskGroup) {
            return withLoadingScreen(async () => {
                await this.experimentTaskGroupsAPI.delete(taskGroup.id);
                this.$emit("deleted", taskGroup);
            });
        },
        taskGroupsSaved(taskGroups) {
            this.$emit("saved", taskGroups);
        },
    },
});
</script>
<style></style>
